import React from "react";
import PropTypes from 'prop-types';

export default class LinkButton extends React.PureComponent {
    clickHandler = () => {
        const { onClick, isLoading } = this.props;

        if (isLoading) {
            return false;
        }

        return onClick();
    };
    render() {
        const { className, isLoading, children } = this.props;

        return (
            <div onClick={this.clickHandler} className={`link-button${className ? ` ${className}` : ''}${isLoading ? ' loading' : ''}`}>
               {children}
            </div>
        );
    }
}

LinkButton.propTypes = {
    className: PropTypes.string,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node,
};
